<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">创作中心</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <div>
            切换账号
            <el-select v-model="userId" @change="userChange" placeholder="请选择">
                <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id">
                </el-option>
            </el-select>
        </div>
        <el-divider></el-divider>
        <div v-if="userId != ''">
            <div style="margin-bottom:10px">
                <el-button size="small" type="primary" @click="addPostClick">发帖子</el-button>
                <el-button size="small" type="primary" @click="addvideoClick">发视频</el-button>
            </div>
            <el-radio-group v-model="viewType" @change="viewTypeChange">
                <el-radio-button label="1">作品</el-radio-button>
                <el-radio-button label="2">评论</el-radio-button>
            </el-radio-group>
            <div v-if="viewType == 1">
                <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:10px">
                    <el-form-item label="类型">
                        <el-select v-model="types" placeholder="请选择">
                            <el-option label="帖子" value="2"></el-option>
                            <el-option label="视频" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="status" placeholder="请选择">
                            <el-option label="草稿" value="0"></el-option>
                            <el-option label="发布" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="dataList" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column show-overflow-tooltip prop="title" label="标题" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="readnum" label="播放/阅读" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="点赞" >
                        <template slot-scope="scope">{{scope.row.otherData.interestcount}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="评论" >
                        <template slot-scope="scope">{{scope.row.otherData.commentnum}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="" label="收藏" >
                        <template slot-scope="scope">{{scope.row.otherData.likecount}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="sharenum" label="分享" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="type" label="类型" >
                        <template slot-scope="scope">{{scope.row.type == 3?'视频':'帖子'}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ishow" label="谁可以看" >
                        <template slot-scope="scope">{{scope.row.type == 0?'私密（谁都不可见）':'公开（谁都可见）'}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="status" label="状态" >
                        <template slot-scope="scope">{{scope.row.status == 0?'草稿':'发布'}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="官方账号昵称" >
                        <template slot-scope="scope">{{scope.row.users.nickname}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="createdate" label="创建时间" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="操作人" >
                        <template slot-scope="scope">{{scope.row.adminUsers.name}}</template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="240px">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button size="mini" type="text" @click="delClick(scope.row)">删除</el-button>
                            <el-button v-if="scope.row.status == 0" size="mini" type="text" @click="editOpen(scope.row)">发布</el-button>
                            <el-button size="mini" type="text" @click="seeClick(scope.row)">查看</el-button>
                            <el-button size="mini" type="text" @click="editaaaOpen(scope.row)">查看评论</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </div>
            <div v-if="viewType == 2">
                <el-table size="small" :data="commentData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column show-overflow-tooltip prop="title" label="互动" >
                        <template slot-scope="scope">{{scope.row.auser.nickname}}{{scope.row.type == 0?'评论':'回复'}}你的动态</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="content" label="评论内容" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="内容标题" >
                        <template slot-scope="scope">{{scope.row.hdArticle.title}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="发表用户昵称" >
                        <template slot-scope="scope">{{scope.row.auser.nickname}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="发表用户手机号" >
                        <template slot-scope="scope">{{scope.row.auser.phone}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="integral" label="发表时间" >
                        <template slot-scope="scope">{{scope.row.createdate}}</template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="240px">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="commentContentClick(scope.row)">回复</el-button>
                            <el-button type="text" v-preventReClick @click="commentdelClick(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination v-bind:child-msg="commentPage" @callFather="callcomment"></Pagination>
            </div>            
        </div>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 创建任务 -->
        <el-dialog title="" :visible.sync="addPostFlag" width="45%" @click="addPostClose">
            <el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="请输入标题"></el-input>
            <el-divider></el-divider>
            <quill-editor
                ref="myQuillEditor"
                :content="content"
                :options="editorOption"
                @change="onEditorChange($event)"
            />
            <el-divider content-position="left">封面图：若不传，则从正文中取图片；最多上传9张图</el-divider>
            <el-upload
                class="upload-demo"
                :http-request="HandleChange2"
                :file-list="FileList"
                :on-exceed="onExceed"
                :on-remove="handleRemove"
                multiple
                :limit="9"
                style="margin-top:15px"
                accept=".jpg , .png ,"
                list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            
            <el-divider content-position="left">受众</el-divider>
            <el-form label-width="120px" :model="editForm" ref="editForm">
                <el-form-item label="谁可以看" prop="ishow">
                    <el-select v-model="editForm.ishow" placeholder="请选择">
                        <el-option label="公开（谁都可见）" :value="1"></el-option>
                        <el-option label="私密（谁都不可见）" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否推向全国" prop="">
                    <el-select v-model="editForm.promotion" placeholder="请选择">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="editForm.promotion == 0" label="城市" prop="name">
                    <el-cascader
                        :options="areaTreeList"
                        :props="props"
                        collapse-tags="true"
                        v-model="editForm.area"
                        clearable></el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addPostClose">取消</el-button>
                <el-button size="small" type="primary" v-if="editRowForm.status != 1" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="submitPost(0)">存草稿</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="submitPost(1)">发布</el-button>
            </div>
        </el-dialog>
        <!-- 创建任务 -->
        <el-dialog title="" :visible.sync="addvideoFlag" width="45%" @click="addViodeClose">
            <el-form :model="editForm" label-width="120px" :rules="rules" ref="editForm">
                <el-form-item label="视频:" prop="name">
                    <VideoPlay
                        v-show="VideoUrl != ''"
                        :videoUrl="VideoUrl"
                        :videoCover="videoCover"
                        width="300px"
                        :height="200"
                        :autoplay="true"
                        :controls="true"
                        :loop="false"
                        :muted="false"
                        preload="auto"
                        :showPlay="true"
                        :playWidth="96"
                        zoom="cotain"
                    />
                    <el-upload
                        :http-request="videoChange"
                        :file-list="videoFileList"
                        multiple
                        limit="1"
                        accept=".mp4"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="标题:" prop="name">
                    <el-input size="small" v-model="editForm.title" style="width:220px" auto-complete="off" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="封面图:">
                    <div>若不传，则取视频第一贞</div>
                    <img style="width:300px;height:200px" v-if="videoCoverUrl != ''" :src="videoCoverUrl">
                    <el-upload
                        :http-request="videoCoverChange"
                        :file-list="videoCoverFileList"
                        multiple
                        limit="1"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-divider content-position="left">受众</el-divider>
            <el-form label-width="120px" :model="editForm"  ref="editForm">
                <el-form-item label="谁可以看">
                    <el-select v-model="editForm.ishow" placeholder="请选择">
                        <el-option label="公开（谁都可见）" :value="1"></el-option>
                        <el-option label="私密（谁都不可见）" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否推向全国" prop="">
                    <el-select v-model="editForm.promotion" placeholder="请选择">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="editForm.promotion == 0" label="城市" prop="name">
                    <el-cascader
                        :options="areaTreeList"
                        :props="props"
                        collapse-tags="true"
                        v-model="editForm.area"
                        clearable></el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addViodeClose">取消</el-button>
                <el-button size="small" type="primary" v-if="editRowForm.status == 0" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="submitVideo(0)">存草稿</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="submitVideo(1)">发布</el-button>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="seePostFlag" width="45%" @click="closeDialog">
            <div>
                {{seeForm.title}}
            </div>
            <div>
                <span v-html="seeForm.detail"></span>
            </div>
            <div>
                <img style="width:178px;height:178px;margin:10px 10px 0 0 " v-for="item in seeForm.picList" :key="item" :src="item">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seePostFlag = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 创建任务 -->
        <el-dialog title="" :visible.sync="seevideoFlag" width="45%" @click="closeDialog">
            <div>
                {{seeForm.title}}
            </div>
            <VideoPlay
                :videoUrl="seeForm.videourl"
                :videoCover="videoCover"
                width="100%"
                :autoplay="true"
                :controls="true"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cotain"
            />
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seevideoFlag = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 回复 -->
        <el-dialog :title="title" :visible.sync="commentContentFlag" width="30%" @click="commentContentFlag = false">
        <el-form label-width="120px" :model="addintegralForm" :rules="rules" ref="addintegralForm">
            <el-form-item label="回复" prop="count">
            <el-input size="small" v-model="commentContent" auto-complete="off" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="commentContentFlag = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" v-preventReClick @click="commentContentSubmit('addintegralForm')">发表</el-button>
        </div>
        </el-dialog>
        <el-upload
            v-show="false"
            class="avatar-uploader"
            :data='fileUpload'
            :show-file-list="false"
            :http-request="onUploadHandler"
            >
        </el-upload>
</div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Pagination from '../../components/Pagination'
import VideoPlay from '../video.vue'
import { officialUsersList , areaTree , addArticle ,
     articleList , articleDel ,articleUpdate , articleOpen ,
     commentSelect , commentDel , commentCommit } from '../../api/userMG'
export default {
    data(){
        return{
            commentContentFlag:false,
            commentContentForm:{},
            commentContent:'',
            editRowForm:{},
            userList:[],
            seeForm:{},
            seePostFlag:false,
            seevideoFlag:false,
            dataList:[],
            viewType:'1',
            types:'',
            status:'',
            userId:'',
            areaTreeList:[],
            area:[],
            content: ``,
            editorOption: {
                modules: {
                toolbar: {
                    container: [
                    ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                    [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                    [{ indent: '-1' }, { indent: '+1' }], // 缩进
                    [{ direction: 'rtl' }], // 文本方向
                    // [{ font: ['songti'] }], // 字体种类
                    ['clean'], // 清除文本格式
                    ['image'] // 链接、图片、视频
                    ],
                    handlers: {
                        'image': function (value) {
                            if (value) { // value === true
                                document.querySelector('.avatar-uploader input').click()
                            } else {
                                this.quill.format('image', false)
                            }
                        }
                    }
                }
                },
                placeholder: '请输入正文'
            },
            radio1:'',
            addTaskForm:{
                mode:1
            },
            addPostFlag:false,
            addvideoFlag:false,
            props: { 
                multiple: true,
                emitPath:false,
                label:'name',
                value:'name',
                children:'areachildren'
             },
            options:[],
            editForm:{
                promotion:"1",
                ishow:'',
                title:'',
                area:[]
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                payChannel:'',
                time:[],
                taskType:''
            },
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            commentPage:{
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            commentData:[],
            FileList:[],
            videoFileList:[],
            VideoUrl:'',
            videoCoverFileList:'',
            videoCoverUrl:'',
        }
    },
    components: {
        Pagination,
        quillEditor,
        VideoPlay
    },
    created(){
        this.getdata()
        this.areaTree()
        // this.loadPayChannelList()
    },
    methods:{
        commentContentSubmit(){
            if(this.commentContent == ''){
                this.$message.error('请输入内容')
            }else{
                commentCommit({
                    article_id:this.commentContentForm.article_id,
                    buser_id:this.commentContentForm.auser_id,
                    content:this.commentContent,
                    ktype:this.commentContentForm.ktype,
                    auser_id:this.userId,
                    type:1,
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('回复成功')
                        this.commentContent = ''
                        this.commentContentFlag = false
                    }
                })
            }
        },
        commentContentClick(row){
            console.log(row)
            this.commentContent = ''
            this.commentContentFlag = true
            this.commentContentForm = row
        },
        viewTypeChange(){
            if(this.viewType == 2){
                this.commentPage.currentPage = 1
                this.commentPage.pageSize = 10
                this.commentSelect()
            }
        },
        callcomment(parm){
            this.commentPage.currentPage = parm.currentPage
            this.commentPage.pageSize = parm.pageSize
            this.commentSelect()
        },
        commentSelect(){
            commentSelect({
                page:this.commentPage.currentPage,
                size:this.commentPage.pageSize,
                buid:this.userId
            }).then(res=>{
                this.commentData = res.data.dataList
                this.commentPage.total = res.data.total
            })
        },
        commentdelClick(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                commentDel({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.commentSelect()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        editOpen(row){
            this.$confirm('确定要发布吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                articleOpen({
                    id:row.id,
                    status:1
                }).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.articleList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消发布'
                })
            })
        },
        handleEdit(row){
            if(row.type == 3){
                this.editRowForm = row
                let loc = JSON.parse(row.location)
                this.VideoUrl = row.videourl
                if(row.pic != ''){
                    let imglist = row.pic.split(',')
                    this.videoCoverUrl = imglist[0]
                }
                this.editForm = {
                    ishow:row.ishow,
                    title:row.title,
                    promotion:loc[0] == '中国'?1:0,
                    area:loc[0] == '中国'?[]:loc,
                    id:row.id
                }
                this.addvideoFlag = true
            }else {
                this.editRowForm = row
                this.content = row.detail
                if(row.pic != ''){
                    let imglist = row.pic.split(',')
                    let imgData = []
                    for(let item of imglist){
                        imgData.push({
                            url:item
                        })
                    }
                    this.FileList = imgData
                }
                let loc = JSON.parse(row.location)
                this.editForm = {
                    ishow:row.ishow,
                    title:row.title,
                    promotion:loc[0] == '中国'?1:0,
                    area:loc[0] == '中国'?[]:loc,
                    id:row.id
                }
                this.addPostFlag = true
            }
        },
        seeClick(row){
            if(row.type == 3){
                this.seeForm = row
                this.seevideoFlag = true
            }else {
                row.picList = row.pic == ''?[]:row.pic.split(',')
                this.seeForm = row
                this.seePostFlag = true
            }
        },
        userChange(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.viewType = 1
            this.articleList()
        },
        articleList(){
            articleList({
                page:this.formInline.page,
                size:this.formInline.limit,
                userids:[`${this.userId}`],
                types:this.types == ''?null:[`${this.types}`],
                status:this.status == ''?null:Number(this.status),
                categorys:[2]
            }).then(res=>{
                this.dataList = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.articleList()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.articleList()
        },
        areaTree(){
            areaTree().then(res=>{
                this.areaTreeList = res.data
            })
        },
        addPostClick(){
            this.FileList = []
            this.content = ''
            this.editForm = {
                promotion:1,
                ishow:'',
                title:'',
                area:[]
            }
            this.editRowForm = {}
            this.addPostFlag = true
        },
        addvideoClick(){
            this.editForm = {
                promotion:1,
                ishow:'',
                title:'',
                area:[]
            }
            this.editRowForm = {}
            this.videoCoverUrl = ''
            this.VideoUrl = ''
            this.addvideoFlag = true
        },
        addPostClose(){
            this.FileList = []
            this.content = ''
            this.addPostFlag = false
            this.editForm = {
                promotion:1,
                ishow:'',
                title:'',
                area:[]
            }
        },
        addViodeClose(){
            this.videoCoverUrl = ''
            this.videourl = ''
            this.addvideoFlag = false
            this.editForm = {
                promotion:1,
                ishow:'',
                title:'',
                area:[]
            }
        },
        submitVideo(status){
            console.log(this.editForm)
            if(this.VideoUrl == ''){
                this.$message.error('请上传视频')
            }else if(this.editForm.title == ''){
                this.$message.error('请输入标题')
            }else if(this.editForm.ishow === ''){
                this.$message.error('请选择隐私')
            }else if(this.editForm.promotion == 0 && this.editForm.area.length == 0){
                this.$message.error('请选择城市')
            }else{
                let data = []
                if(this.videoCoverUrl != ''){
                    data.push(this.videoCoverUrl)
                }
                let location = ['中国']
                if(this.editForm.id == undefined){
                    addArticle({
                        videourl:this.VideoUrl,
                        userid:this.userId,
                        category:2,
                        ishow:this.editForm.ishow,
                        type:3,
                        title:this.editForm.title,
                        pic:data.join(','),
                        status:status,
                        location:this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area)
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success(status == 1?'发布成功':'保存成功')
                            this.addvideoFlag = false
                            this.articleList()
                        }
                    })
                }else {
                    let dataForm = this.editRowForm
                    dataForm.videourl = this.VideoUrl,
                    dataForm.userid = this.userId,
                    dataForm.category = 2,
                    dataForm.ishow = this.editForm.ishow,
                    dataForm.type = 3,
                    dataForm.title = this.editForm.title,
                    dataForm.pic = data.join(','),
                    dataForm.status = status,
                    dataForm.location = this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area)
                    articleUpdate(dataForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success(status == 1?'发布成功':'保存成功')
                            this.addvideoFlag = false
                            this.articleList()
                        }
                    })
                }
                
            }
        },
        submitPost(status){
            if(this.editForm.title == ''){
                this.$message.error('请输入标题')
            }else if(this.content == ''){
                this.$message.error('请输入正文')
            }else if(this.editForm.ishow === ''){
                this.$message.error('请选择隐私')
            }else if(this.editForm.promotion == 0 && this.editForm.area.length == 0){
                this.$message.error('请选择城市')
            }else {
                let content = this.content
                let imgList = []
                let location = ['中国']
                if(this.FileList.length == 0){
                    let tr = content.match(/https(.*?)\"/g);
                    if(tr != null){
                        for(let item of tr){
                            imgList.push(
                                item.substring(0 , item.length-1)
                            )
                        }
                    }
                }else {
                    for(let item of this.FileList){
                        imgList.push(item.url)
                    }
                }
                if(this.editForm.id == undefined){
                    addArticle({
                        userid:this.userId,
                        category:2,
                        ishow:this.editForm.ishow,
                        type:2,
                        title:this.editForm.title,
                        pic:imgList.join(','),
                        detail:this.content.replace(/img/g,`img style="width:100%"`),
                        status:status,
                        location:this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area)
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success(status == 1?'发布成功':'保存成功')
                            this.addPostFlag = false
                            this.articleList()
                        }
                    })
                }else {
                    let data = this.editRowForm
                    data.id = this.editForm.id,
                    data.userid = this.userId,
                    data.category = 2,
                    data.ishow = this.editForm.ishow,
                    data.type = 2,
                    data.title = this.editForm.title,
                    data.pic = imgList.join(','),
                    data.detail = this.content.replace(/img/g,`img style="width:100%"`),
                    data.status = status,
                    data.location = this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area)
                    articleUpdate(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success(status == 1?'发布成功':'保存成功')
                            this.addPostFlag = false
                            this.articleList()
                        }
                    })
                }
            }
        },
        editSubmit(){
            // let str = '<p><img src=\"https://mjdcdntest.17yp.com/mini/video/2023101014103524608012.png\"><img src=\"https://mjdcdntest.17yp.com/mini/video/2023101014104923708329.png\"></p>'
            // let tr = str.match(/https(.*?)\"/g);
            // let data = []
            // for(let item of tr){
            //     data.push(
            //         item.substring(0 , item.length-1)
            //     )
            // }
            // console.log(data)
            // console.log(str.replace(/img/g,`img style="width:100%"`))
                console.log(this.area)
        },
        onEditorChange(e){
            this.content = e.html
            console.log(e)
        },
        handleRemove(e){
            console.log(e.url)
            let data = []
            for(let item of this.FileList){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.FileList = data
        },
        onExceed(){
            this.$message.error("文本超限")
        },
        videoCoverChange(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.videoCoverUrl = res.data.data
                this.videoCoverFileList = []
            })
        },
        // 上传视频
        videoChange(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.VideoUrl = res.data.data
                this.videoFileList = []
            })
        },
        // 上传帖子封面图
        HandleChange2(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.FileList.push({
                    url:res.data.data
                })
            })
        },
        async onUploadHandler(file) {
            let formData = new FormData()
            formData.append('file' ,file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                // 获取光标所在位置
                let quill = this.$refs.myQuillEditor.quill
                let length = quill.getSelection().index
                // 插入图片
                quill.insertEmbed(length, 'image', res.data.data)
                // 调整光标到最后
                quill.setSelection(length + 1)
            })
        },
        
        deleteTask(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTask({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addTaskSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    saveOrUpdateTask({
                        mode:this.addTaskForm.mode,
                        type:this.options[this.addTaskForm.taskType].type,
                        name:this.options[this.addTaskForm.taskType].name,
                        palyTimes:this.addTaskForm.palyTimes,
                        integral:this.addTaskForm.integral,
                        id:this.addTaskForm.id == undefined?'':this.addTaskForm.id
                    }).then(res=>{
                        if(res.success){
                            this.$message.success('创建成功')
                            this.addTaskForm = {
                                mode:1,
                                type:'',
                                integral:'',
                                palyTimes:'',
                            }
                            this.addTaskFlag = false
                            this.getdata()
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        sortClick(row , index , type){
            let associationId = ''
            if(type == 'top'){
                associationId = this.listData[index - 1].id
            }else if(type == 'bottom') {
                associationId = this.listData[index + 1].id
            }
            changeTaskSort({
                id:row.id,
                associationId:associationId
            }).then(res=>{
                if(res.success){
                    this.$message.success('操作成功')
                    this.listData = res.tasks
                }
            })
        },
        selectChange(event){
            console.log(event)
            if(this.options[event].type == 4){
                this.palyTimesFlag = true
            }else {
                this.palyTimesFlag = false
            }
        },
        addTask(){
            this.addTaskFlag = true
            this.palyTimesFlag = false
            this.addTaskForm = {
                mode:1,
                type:'',
                integral:'',
                palyTimes:'',
                taskType:''
            }
            this.getTaskListForNew()
        },
        radioClick(){
            this.getTaskListForNew()
        },
        getTaskListForNew(){
            getTaskListForNew({
                mode:this.addTaskForm.mode
            }).then(res=>{
                this.addTaskForm.taskType = ''
                this.palyTimesFlag = false
                this.options = res.taskModels
            })
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.formInline.payChannel = ''
            this.formInline.time = []
            this.getdata()
        },
        loadPayChannelList(){
            loadPayChannelList({
                
            }).then(res=>{
                this.channelsList = res.channels
            })
        },
        getdata(){
            officialUsersList({
                page:1,
                size:500,
                type:1
            }).then(res=>{
                this.userList = res.data.dataList
            })
        },
        delClick(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                articleDel({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.articleList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        }
        
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/socialize/CreativeCenter.vue